{
  "button": "Export to calendar",
  "heading": "Export to calendar",
  "refresh_button": "Refresh link",
  "refresh_instructions": "Make the current link invalid and get a new one",
  "switch_label": "Schedule feed enabled",
  "confirm_refresh": {
    "title": "Refresh feed link for {{schedule}}?",
    "message": "Users with the current feed URL will no longer be able to import your schedule.",
    "refresh": "Reset",
    "success_toast": "Feed link refreshed!"
  },
  "enable_error": "Error enabling a public ICS feed",
  "advanced": "Advanced"
}
